import React, {useContext, useEffect, useState } from 'react';
import {SystemManager_API} from "../../SystemManager.API";
import {useParams} from "react-router-dom";
import {AuthContext} from "../../../../context/AuthContext";
import Page from "../../../../components/Pages/Page";
import BreadCrumbsItems from "../../../../components/Pages/BreadCrumbsItems/BreadCrumbsItems";
import { useAPI } from '../../../../hooks/useAPI'


function VerCanterPrices() {
    const {getVerCenterDoctorPrices, saveVerCenterDoctorPrices} = SystemManager_API.counterAgents.verificationCenter
    const {verCenterId,verCenterName,doctorId,doctorName} = useParams()
    const {REACT_APP_URL_PREFIX} = process.env
    const {token} = useContext(AuthContext)
	const { APIRequest } = useAPI()
	const [prices, setPrices] = useState([]);
	const [title, setTitle] = useState(verCenterName);

	useEffect(async () => {
		await APIRequest(getVerCenterDoctorPrices(token.userId,verCenterId,doctorId))
			.then(response => {
			  if (response.body) {
				  setPrices(response.body?.prices);
			  }
			})
	}, []); // Pass empty array to only run once on mount.

	const breadCrumbsItems = [
        {title: 'Контрагенты'},
        {title: 'Удостоверяющие центры',  link: process.env.REACT_APP_URL_PREFIX + `/counterAgents/verificationCenters`},
        {title: verCenterName},
        {title: 'Цены и специализации доктора'},
        {title: doctorName, actual: true},
    ]
	
	const setPriceFor = (newval,idxs)=>{
		setPrices(prices.map((price) =>
			price.study_title === idxs
				? { ...price, price: newval}
				: { ...price }
		));
	}
	const setEnabledFor = (newval,idxs)=>{
		setPrices(prices.map((price) =>
			price.study_title === idxs
				? { ...price, enabled: newval}
				: { ...price }
		));
	}
	
	const savePrices = async()=>{
		await APIRequest(saveVerCenterDoctorPrices(token.userId,verCenterId,doctorId), {prices: prices})
			.then(response => {
			  if (response.body) {
				  alert(response.body?.message);
			  }
			})
	}

    return (
        <>
            <Page mobile={true}>
                <BreadCrumbsItems style={{left: '100px'}} routes={breadCrumbsItems}/>
				<div style={{paddingTop: 100, paddingLeft:30,paddingRight:30,paddingBottom:30}}>
					<table>
					 <tr>
					  <td>Читает</td>
					  <td>Обследование</td>
					  <td>Цена чтения</td>
					 </tr>
					{prices.map(function(d, idx){
						 return (<tr key={idx}>
							<td><input type="checkbox" checked={d.enabled} style={{opacity: 1, width: 25,height: 25, position: 'inherit'}}
								onChange={()=>{setEnabledFor(!d.enabled,d.study_title)}}/></td>
							<td>{d.study_title}</td>
							<td>{d.enabled ? <input value={d.price} placeholder={d.default_price} style={{color: '#f00'}}
								onChange={(event)=>{setPriceFor(event.target.value,d.study_title)}}/> : undefined}</td>
						 </tr>)
				    })}
					</table>
					<button onClick={()=>{savePrices()}} style={{padding: 7}}>Сохранить</button>
				</div>
				<p style={{padding: 20}}>
					Цена красным если задана для этого доктора, серым если она "наследуется" от цен организации. 
					Удалите красную цену у доктора в этой таблице, чтобы автоматически ставилась цена организации.</p>
            </Page>
        </>
    );
}

export default VerCanterPrices;


